/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Wlanpassword1Inputs */

const de__field_wlanpassword1 = /** @type {(inputs: _Field_Wlanpassword1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WLAN-Passwort`)
};

/**

* @param {_Field_Wlanpassword1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_wlanpassword1 = /** @type {((inputs?: _Field_Wlanpassword1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Wlanpassword1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_wlanpassword1(inputs)
});
export { _field_wlanpassword1 as "_field_wlanPassword" }